export default "__VITE_ASSET__DnotWIIr__"